export const ArrowTopIcon = ({ size = 24, color = 'currentColor' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            width={size}
            height={size}
            viewBox="0 0 24 24"
        >
            <path d="M7.41 18.205L12 13.615L16.59 18.205L18 16.795L12 10.795L6 16.795L7.41 18.205ZM6 7.79502L6 5.79502L18 5.79502L18 7.79502L6 7.79502Z"/>
        </svg>
    );
}